import { TEXTS } from "@payment-ui/constants";
import { format } from "@swiggy-private/core-ui";
import {
    PaymentMethod,
    PaymentMethodMeta,
    VALID_PAYMENT_METHODS,
    VALID_PAYMENT_GROUP_TYPES,
} from "@swiggy-private/payment-types";
import { InAppUpiPaymentMethod } from "@payment-ui/interfaces";

export const isInAppUpiOnboardingMethod = (method: PaymentMethod<PaymentMethodMeta>): boolean =>
    VALID_PAYMENT_METHODS.NEW_INAPP_UPI_ONBOARDING === method.name.toUpperCase();

export const isNewInAppUpiPaymentMethod = (methodData: InAppUpiPaymentMethod): boolean => {
    const { name } = methodData;
    return VALID_PAYMENT_METHODS.NEW_INAPP_UPI === name.toUpperCase();
};

export const isInAppUpiPaymentMethod = (method: PaymentMethod<PaymentMethodMeta>): method is InAppUpiPaymentMethod => {
    return [VALID_PAYMENT_GROUP_TYPES.INAPP_UPI].includes(method.groupName.toUpperCase());
};

export const isInAppUpiLitePaymentMethod = (method: InAppUpiPaymentMethod): method is InAppUpiPaymentMethod => {
    return (
        ([VALID_PAYMENT_GROUP_TYPES.INAPP_UPI].includes(method.groupName.toUpperCase()) &&
            method?.meta?.accountType?.includes("LITE")) ??
        false
    );
};

export const getPayCtaMsg = (methodData: InAppUpiPaymentMethod, paymentAmount: string): string => {
    if (methodData?.meta?.mpinSet === false) {
        return methodData.meta.ctaMsg ?? format(TEXTS.SETUP_PIN_AND_PAY_X, paymentAmount);
    }
    return methodData.meta.ctaMsg ?? format(TEXTS.PAY_X, paymentAmount);
};

export const getInAppPaymentMethodExtraParams = (methodData: InAppUpiPaymentMethod) => {
    const meta = methodData?.meta;

    return {
        /* eslint-disable @typescript-eslint/naming-convention */
        in_app_upi_params: {
            account_reference_id: meta?.referenceId || "",
            account_type: meta?.accountType || "",
        },
        /* eslint-enable */
    };
};
